import React, { useEffect, useState } from "react";
import { ActionHandlerFunction, PaginationItem } from "@preveil-api";
import { DriveUIActionTypes } from "src/common";
import { PaginationDisplay, Pagination, ToolbarButton, ToolbarWrapper, ToolbarFilter, Icon } from "src/components";

type AllProps = {
  is_loading: boolean;
  pagination?: PaginationItem;
  selected: string[];
  counts?: number;
  filter_count?: number;
  handleAction: ActionHandlerFunction;
}

// Description: This component renders the toolbar for the Drive Starred section, providing actions like filtering, un-starring, pagination and refreshing
function ToolbarComponent(props: AllProps) {
  const { is_loading, pagination, selected, counts, filter_count, handleAction } = props;
  const [disabled, setDisabled] = useState<boolean>(true);
  const [filter_param, setFilterParam] = useState<string>("");
  const [filtering, setFiltering] = useState<boolean>(false);

  useEffect(() => {
    (!!pagination && pagination.totalRows > 0) ?
      setDisabled(selected.length <= 0) : setDisabled(true);
  }, [selected, pagination]);

  // Description: reset filters on pagination and on click of x
  function resetFilters() {
    setFilterParam("");
    setFiltering(false);
    handleAction({ actionType: DriveUIActionTypes.Filter, params: "" });
  }

  const pagination_info = !!pagination ? (
    filtering
      ? <div className="fw-medium pagination_info">{filter_count} of {pagination.totalRows}</div>
      : <PaginationDisplay pagination={pagination} />
  ) : <></>;

  return <ToolbarWrapper
    leftContent={<ToolbarFilter
      disabled={is_loading || counts === 0}
      placeholder="Filter by items name in this page..."
      filter_param={filter_param}
      onChange={(value) => {
        !!value ? setFiltering(true) : setFiltering(false);
        setFilterParam(value);
        handleAction({ actionType: DriveUIActionTypes.Filter, params: value });
      }}
      onClick={resetFilters} />}
    pagination={!!pagination && !filtering ? <Pagination pagination={pagination} handleAction={(params) => { resetFilters(); handleAction(params); }} /> : <></>}
    paginationInfo={pagination_info}
    refreshAction={() => { resetFilters(); handleAction({ actionType: DriveUIActionTypes.Refresh }); }}
    refreshTooltipContent="Refresh Starred Items"
    isLoading={is_loading}
  >
    <ToolbarButton
      disabled={disabled}
      onClick={() => handleAction({ actionType: DriveUIActionTypes.Unstar, params: selected })}
      ariaLabel="Remove Starred Status"
      tooltipContent="Remove Starred Status">
      <Icon className="ficon-star" />
    </ToolbarButton>
  </ToolbarWrapper>;
}

export default React.memo(ToolbarComponent);
